import { get } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

const hostedTimeFacilityResponseSchema = z
  .object({
    deviceId: z.number().nullable().optional(),
    name: z.string().nullable().optional(),
  })
  .nullable();

export type HostedTimeFacilityResponse = z.infer<typeof hostedTimeFacilityResponseSchema>;

interface UseGetHostedTimeFacilityParams {
  facilityId: string;
}

interface UseGetHostedTimeFacilityOptions {
  enabled?: boolean;
}

const HOSTED_TIME_FACILITY_URL = `${environmentConfig.REACT_APP_BASE_API_URL}/hosted-time/facility`;

export function useGetHostedTimeFacility(
  parameters: UseGetHostedTimeFacilityParams,
  options: UseGetHostedTimeFacilityOptions = {}
) {
  const { facilityId } = parameters;
  const { enabled = true } = options;

  return useQuery({
    queryKey: [HOSTED_TIME_FACILITY_URL, facilityId],
    queryFn: async () => {
      const response = await get({
        url: `${HOSTED_TIME_FACILITY_URL}/${facilityId}`,
        responseSchema: hostedTimeFacilityResponseSchema,
      });
      return response.data;
    },
    enabled: enabled && Boolean(facilityId),
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_FACILITY_PROFILE_FAILED,
    },
  });
}
